import {
    HeaderWrapper,
    Logo,
    MenuContainer,
    ActionButton
} from "./styles";
import Row from '../Kit/Row';
import Menu from "./Menu";

const Header = (props) => {
    const {
        headerColor,
        activeSection
    } = props;

    return (
        <HeaderWrapper className="header">
            <Row className="content">
                <a href='/'>
                    <Logo
                        source={headerColor === "white"
                            ? "/Assets/Images/Logo.svg"
                            : "/Assets/Images/LogoLight.svg"
                        }
                    />
                </a>
                <MenuContainer
                    headerColor={headerColor}
                >
                    <Menu activeSection={activeSection} />
                </MenuContainer>
                <ActionButton
                    href={window.config.urls.customerPanelURL}
                    target="_blank"
                >
                    ورود
                </ActionButton>
            </Row>
        </HeaderWrapper>
    )
}

export default Header;